export enum SessionKeeperAction {
	Idle = 'IDLE',
	Logout = 'LOGOUT',
	Running = 'RUNNING',
	ShowPopup = 'SHOW_POPUP',
}
